import { z } from "zod";

export const name = z.string().nonempty("Name is required");
export const email = z.string().email("Invalid email");
export const phone = z.string().nonempty("Phone number is required");
export const creditCard = z.number({ message: "Credit Card must be a number" });
export const emptySchema = z.any();
